import { useViewedItems } from './useViewedItems';

export function useViewedQuotes() {
  return useViewedItems('arbor:viewedQuoteIds');
}
